module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/080-iceland-ebb0bb6a7145d20b4976cee3e3d54d46.svg";